import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';
import './LoginForm.css';

function ForgotPasswordForm({ onSwitchToLogin, onSuccess }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    if (!email) {
      setError('Veuillez entrer votre adresse email');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/auth/forgot-password`, { email });

      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.message || 'Une erreur est survenue');
      }
    } catch (err) {
      console.error('Erreur forgot password:', err);
      setError(err.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-form-container">
        <h2>✉️ Email envoyé</h2>
        <p className="form-subtitle">Vérifiez votre boîte de réception</p>
        
        <div style={{ textAlign: 'center', padding: '2rem 0' }}>
          <p style={{ marginBottom: '1.5rem', color: '#666' }}>
            Si cette adresse email existe dans notre système, vous recevrez un lien de réinitialisation de mot de passe par email.
          </p>
          <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '0.9rem' }}>
            Le lien est valide pendant 1 heure.
          </p>
        </div>

        {onSwitchToLogin && (
          <div className="form-footer">
            <button
              type="button"
              onClick={onSwitchToLogin}
              className="link-button"
            >
              ← Retour à la connexion
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="login-form-container">
      <h2>🔑 Mot de passe oublié</h2>
      <p className="form-subtitle">Entrez votre email pour recevoir un lien de réinitialisation</p>

      <form onSubmit={handleSubmit} className="auth-form">
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre@email.com"
            disabled={loading}
            required
          />
        </div>

        {error && (
          <div className="alert-error">
            ❌ {error}
          </div>
        )}

        <button
          type="submit"
          className="btn-primary"
          disabled={loading}
        >
          {loading ? '⏳ Envoi...' : '📧 Envoyer le lien de réinitialisation'}
        </button>
      </form>

      <div className="form-footer">
        <p>
          Vous vous souvenez de votre mot de passe ?{' '}
          <button 
            type="button" 
            onClick={onSwitchToLogin}
            className="link-button"
          >
            Se connecter
          </button>
        </p>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
